import {useEffect, useMemo} from 'react';
import {useQuestionReportData} from '../../../../hooks/useQuestionReportData';
import {ISlide} from '../../../../incase-domain/slide';
import {IQuestionReportElement} from '../../../../incase-domain/elements/question/questionReportElement';
import {
    buildHtmlQuestionReportPayload,
    findHtmlReportQuestion,
    publishHtmlQuestionReport,
} from '../../../../incase-domain/elements/html/questionReportSlot';

interface HtmlQuestionReportBridgeProps {
    element: IQuestionReportElement;
    slot: HTMLElement;
    slides: ISlide[];
    slideName: string;
}

function HtmlQuestionReportBridge({element, slot, slides, slideName}: HtmlQuestionReportBridgeProps): null {
    const question = useMemo(() => findHtmlReportQuestion(slides, element, slideName), [element, slideName, slides]);
    const report = useQuestionReportData(question?.id || element.questionElementId);
    const payload = useMemo(() => buildHtmlQuestionReportPayload(question, report), [question, report]);

    useEffect(() => {
        publishHtmlQuestionReport(slot, payload);
    }, [payload, slot]);

    return null;
}

export default HtmlQuestionReportBridge;
